import React, { useEffect, useContext } from "react";
import { AuthContext } from "../../utils/authProvider";

export default function SigninSSO() {
  const authService = useContext(AuthContext);

  useEffect(() => {
  const finalizeSSOLogin = async () => {
    try {
      await authService.signinRedirectCallback();
      const user = await authService.getUser();
      await authService.exchangeSSOToken(user.token_type, user.access_token, user.id_token, user.expires_in, user.scope);
      window.location.replace("/signinprofile");
    } catch (err) {
      console.error("SigninSSO error:", err);

      let userMessage;
      switch (err.message) {
          case "USER_NOT_FOUND":
          case "USER_INACTIVE":
           userMessage = "Account does not exist. Please contact your support.";
            break;
        case "SSO_EXCHANGE_FAILED":
          userMessage = "Unable to complete SSO login. Please try again later.";
          break;

        default:
          userMessage = "An unknown error occurred. Please try again or contact support.";
          break;
      }
      sessionStorage.setItem("loginError", userMessage);
      window.location.replace("/login");
    }
  };

  finalizeSSOLogin();
}, [authService]);


  return <p>Authentication in progress...</p>;
}
